export class KeyEventListener {
  public allowFloatNumbersOnly(event: KeyboardEvent): boolean {
    let charCode = event.which ? event.which : event.keyCode;
    if (
      charCode != 45 &&
      charCode != 46 &&
      charCode > 31 &&
      (charCode < 48 || charCode > 57)
    )
      return false;
    return true;
  }

  public allowIntNumbersOnly(event: KeyboardEvent): boolean {
    let charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  }
}
